import { render, staticRenderFns } from "./actionPostMortem.vue?vue&type=template&id=c00ab88a&scoped=true"
import script from "./actionPostMortem.vue?vue&type=script&lang=js"
export * from "./actionPostMortem.vue?vue&type=script&lang=js"
import style0 from "./actionPostMortem.vue?vue&type=style&index=0&id=c00ab88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00ab88a",
  null
  
)

export default component.exports